import { IconVideoEmpty } from "@icons/common";
import { PostVideoButton } from "@components/PostVideoButton/PostVideoButton";
import { Trans } from "react-i18next";

export interface PublishedEmptyStateProps {
  onPostVideo: () => void;
}

export const PublishedEmptyState = ({ onPostVideo }: PublishedEmptyStateProps) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-[12px]">
      <IconVideoEmpty className="size-[110px] shrink-0" aria-hidden />
      <div className="flex flex-col items-center gap-[4px]">
        <p className="text-center text-[16px] font-medium leading-[22px] text-kds-fg">
          <Trans>No Videos Posted Yet</Trans>
        </p>
        <p className="max-w-[507px] text-center text-[14px] leading-[20px] text-kds-fg-soft">
          <Trans>Publish your first video to engage your audience and track performance.</Trans>
        </p>
      </div>
      <PostVideoButton variant="primary" onClick={onPostVideo} />
    </div>
  );
};
